import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const COMPREHENSIVE = 'https://cdn.magicpatterns.com/patterns/generated-images/3dc6f4d8-3d1f-4023-b346-79228eebc173.jpg';
const CALLOUTS = ['Your goal stays front and center, instilling it in your mind every day.', 'Gamified progress bars connect your habits and projects to what matters.', '5 daily reflection questions that take just 5 minutes to answer.', 'Habit stacks and time-blocking patterns from world-class performers.'];
export function CloserLook() {
  return <section className="w-full bg-white py-24" data-id="element-11" data-mp="y91stgqz1eku">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-12" data-mp="y88i64ow64xf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-13" data-mp="12zi7f46j368s">
          <h2 className="text-3xl font-extrabold tracking-tight text-ink sm:text-4xl" data-id="element-14" data-mp="1311m4qcjd98g">
            Take A Closer Look
          </h2>
          <p className="mt-4 text-lg text-muted" data-id="element-15" data-mp="ajfu0ueih1dd">
            The most comprehensive page in GPS Journal — everything you need, in one calm view.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="mt-14 grid items-center gap-10 rounded-3xl border border-line bg-neutral-50 p-6 sm:p-10 lg:grid-cols-2" data-id="element-16" data-mp="3vgzhvb6258rm">
          <img src={COMPREHENSIVE} alt="The most comprehensive page of GPS Journal" className="w-full rounded-2xl border border-line bg-white" data-id="element-17" data-mp="3bqnodkxwvn83" />

          <div data-id="element-18" data-mp="32pzbitk97sws">
            <ul className="space-y-4" data-id="element-19" data-mp="32pft7bqoz2i8">
              {CALLOUTS.map(c => <li key={c} className="flex items-start gap-3" data-id="element-20" data-mp="2xreawt13b77t">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ink text-white" data-id="element-21" data-mp="2xsz52hjhso55">
                    <CheckIcon className="h-3.5 w-3.5" data-id="element-22" data-mp="vzrs3ercqimf" />
                  </span>
                  <span className="leading-relaxed text-ink" data-id="element-23" data-mp="vxor5zonv52x">{c}</span>
                </li>)}
            </ul>

            <a href="#pricing" className="mt-8 inline-flex rounded-full bg-ink px-7 py-3.5 text-sm font-semibold text-white transition-transform hover:scale-[1.03]" data-id="element-24" data-mp="2v6gaz9eyvh0g">
              Get GPS Journal
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}